(() => {
 const setup = () => {
  document.querySelectorAll('.ks-barbell-story .knb-accordion-heading').forEach(heading => {
   if (heading.dataset.ksReady) return;
   heading.dataset.ksReady = 'true';
   heading.setAttribute('role','button');
   heading.tabIndex = 0;
   const body = heading.nextElementSibling;
   heading.setAttribute('aria-expanded',String(body?.classList.contains('knb-accordion-active')));
   const toggle = () => {
    const expanded = heading.getAttribute('aria-expanded') === 'true';
    heading.setAttribute('aria-expanded',String(!expanded));
    body?.classList.toggle('knb-accordion-active',!expanded);
    heading.parentElement.classList.toggle('knb-accordion-active',!expanded);
   };
   heading.addEventListener('click',toggle);
   heading.addEventListener('keydown',event => {if(event.key==='Enter'||event.key===' '){event.preventDefault();toggle();}});
  });
  document.querySelectorAll('.ks-barbell-story a[href="#"]').forEach(link => {
   if (link.dataset.ksReady) return;
   link.dataset.ksReady = 'true';
   if (/close|cta/.test(link.className)) link.addEventListener('click',event => {
    event.preventDefault();
    document.querySelector('.ks-barbell-head')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   });
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
})();
